import PageGallery from '../../../common/ts/components/PageGallery';
import LazyLoadingComponent from "../../../common/ts/components/LazyLoadingComponent";
import GA4Tracking from "../../../common/ts/core/tracking/GA4Tracking";
import dom from "../../../common/ts/core/dom";

class Listings {
  private lazyLoading = new LazyLoadingComponent();

  constructor() {
    dom.init();
  }

  public init() {
    this.trackGA4SerpEvents();
    this.lazyLoading.setupLazyLoading();
    this.saveLastLoadSerpUrl();
  };

  private trackGA4SerpEvents = () => {
    GA4Tracking.trackEvent("serp-pageview");
    if (this.isRetentionEmail()) {
      GA4Tracking.trackEvent("serp-email-signin");
    }
  };

  private isRetentionEmail: () => boolean = () => {
    return document.querySelector("[data-isRetentionEmail]") != null;
  };

  private saveLastLoadSerpUrl() {
    const url = decodeURIComponent(window.location.href);
    localStorage.setItem("lastSerpUrl", url);
  }
}
// eslint-disable-next-line no-new
new PageGallery();
new Listings().init();